import React, { ReactNode } from 'react';

import { UserRole } from 'enums';
import {
  hasRequiredRoleSelector,
  isTeammateSelector,
} from 'redux/selectors/authenticationSelectors';
import { useAppSelector } from 'hooks/useAppSelector';

type Props = {
  roles: UserRole[];
  children: ReactNode;
  teammateRoles?: UserRole[];
};
// A wrapper to check if user has permission to the content
export default function Accessor(props: Props) {
  const { roles, children, teammateRoles = [] } = props;
  const hasRequiredRole = useAppSelector(hasRequiredRoleSelector(roles));
  const isTeammateRole = useAppSelector(isTeammateSelector);
  const hasRequiredTeammateRoleSelector = useAppSelector(
    hasRequiredRoleSelector(teammateRoles),
  );
  const hasSubUserAccess =
    isTeammateRole && teammateRoles.length > 0
      ? hasRequiredTeammateRoleSelector
      : true;

  const isAccess = isTeammateRole
    ? hasSubUserAccess && hasRequiredRole
    : hasRequiredRole;

  if (!isAccess) return null;

  return <>{children}</>;
}
